import { Base64Schema, ObjectIdSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const GetInvoicePdfResponseSchema = oz.object({
  invoiceId: ObjectIdSchema,
  encodedPdf: Base64Schema,
}).openapi('GetInvoicePdfResponse');

export type GetInvoicePdfResponse = oz.TypeOf<typeof GetInvoicePdfResponseSchema>;